<template>
  <TopGradientBlockLayout>
    <div class="text-xl font-bold text-text leading-tight mb-11">{{ $t('title') }}</div>
    <div class="space-y-12">
      <div class="grid lg:grid-cols-2 items-center col-gap-12 row-gap-6">
        <BaseInput v-model.trim="name"
                   :label="$t('nameLabel')">
        </BaseInput>
        <div class="text-xs text-text-ternary">{{ $t('nameTip') }}</div>
      </div>
      <div class="grid lg:grid-cols-2 items-center col-gap-12 row-gap-6">
        <BaseSelect v-model="country_obj"
                    :options="countries"
                    :select-label="$t('countryLabel')"
                    :label="`name_${$i18n.locale}`"
                    :searchable="true"
                    :show-labels="false"
                    @input="handleCountry"/>
      </div>
      <div class="grid lg:grid-cols-2 items-center col-gap-12 row-gap-6">
        <BaseSelect v-model="city_obj"
                    :options="cities"
                    :select-label="$t('cityLabel')"
                    :label="`name_${$i18n.locale}`"
                    :searchable="true"
                    :show-labels="false">
          <template v-slot:noOptions="">
            {{ $t('checkCountryFirst') }}
          </template>
        </BaseSelect>
      </div>
      <div class="grid lg:grid-cols-2 items-center col-gap-12 row-gap-6">
        <BaseSelect v-model="lang_selected"
                    :options="lang_list"
                    :select-label="$t('langLabel')"
                    label="title"
                    :searchable="false"
                    :show-labels="false"
                    :allow-empty="false"
                    @input="handleLocale"/>
      </div>
      <BaseButton theme="gray"
                  class="w-91"
                  :loading="saving"
                  @click="saveSettings">
        {{ $t('save') }}
      </BaseButton>
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "ThePersonalization",
  components: {
    BaseButton,
    BaseSelect,
    BaseInput,
    TopGradientBlockLayout,
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapGetters('cabinet/countries', {
      countries: 'countriesSortedAlphabet',
      cities: 'citiesSortedAlphabet',
    })
  },
  data() {
    return {
      saving: false,
      name: null,
      title_placeholder: '',
      country_obj: null,
      city_obj: null,
      lang_selected: null,
      lang_list: [{
        val: 'en',
        title: 'English'
      }, {
        val: 'ru',
        title: 'Русский'
      }],
    }
  },
  methods: {
    ...mapActions('cabinet/user', ['updateUser']),
    ...mapActions('cabinet/countries', ['getCountries', 'getCities']),
    ...mapMutations('cabinet/countries', ['clearCities']),
    handleLocale(obj) {
      this.$store.dispatch('i18n/changeLang', obj.val);
      this.lang_selected = obj;
    },
    handleCountry(val) {
      if (val === null) {
        this.city_obj = null;
        this.clearCities();
      } else {
        this.getCities(val.code);
      }
    },
    async saveSettings() {
      try {
        this.saving = true;
        let data = {
          id: this.user_info.data.id,
          name: this.name,
          language: this.lang_selected.val,
          country_id: !!this.country_obj ? this.country_obj.id : null,
          city_id: !!this.city_obj ? this.city_obj.id : null,
        };
        const res = await this.updateUser(data);
        if (res.body.success) {
          this.$toasted.success('Изменения сохранены');
          this.$store.commit('cabinet/user/setUserInfo', res.body.data.user);
        } else {
          console.log(res);
          this.$toasted.error('Произошла ошибка');
        }
      } catch (err) {
        console.log(res);
        this.$toasted.error('Произошла ошибка');
        this.saving = false;
      } finally {
        this.saving = false;
      }

    },
    async setFields() {
      let user = this.user_info.data;
      this.name = user.name;
      this.title_placeholder = user.username;
      this.lang_selected = this.lang_list.find(i => i.val === user.language);
      if (!this.countries.length) {
        await this.getCountries();
      }
      this.country_obj = !!user.country_id ? this.countries.filter(i => i.id === user.country_id)[0] : null;
      if (!!this.country_obj) {
        await this.getCities(this.country_obj.code);
        this.city_obj = !!user.city_id ? this.cities.filter(i => i.id === user.city_id)[0] : null;
      }
    },
  },
  async created() {
    await this.setFields();
  },
  i18n: {
    messages: {
      en: {
        title: 'Personalization',
        nameLabel: 'How should we call you?',
        nameTip: 'Please tell us not to name you by login',
        countryLabel: 'Country',
        cityLabel: 'City',
        langLabel: 'Language of interface',
        checkCountryFirst: 'Please select your country first!',
        save: 'Save'
      },
      ru: {
        title: 'Персонализация',
        nameLabel: 'Как к вам обращаться?',
        nameTip: 'Укажите, чтобы мы не обращались к вам по логину',
        countryLabel: 'Страна',
        langLabel: 'Язык интерфейса',
        cityLabel: 'Город',
        checkCountryFirst: 'Сперва выберите вашу страну!',
        save: 'Сохранить'
      }
    }
  }
}
</script>